import { signInWithCustomToken, signOut } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions'; // Removed connectFunctionsEmulator för production
import { auth, functions } from '../config/firebase';
import { AuthenticateReturnType, GetAuthSessionReturnType } from './types';

enum CF {
  AUTH = 'authenticate',
  SESSION = 'getAuthSession'
}

export const authenticateUser = async (): Promise<{
  errorMessage?: string;
  redirectUrl?: string;
}> => {
  try {
    // Använder nu production functions istället för emulator
    // if (process.env.NODE_ENV !== 'production') {
    //   connectFunctionsEmulator(functions, 'localhost', 5001);
    // }
    const authenticate = httpsCallable(functions, CF.AUTH);
    const res = await authenticate();
    const resData = res.data as AuthenticateReturnType;

    if (!resData.data?.redirectUrl) {
      return {
        errorMessage: 'Kunde inte autentisiera användare...'
      };
    }
    return {
      redirectUrl: resData.data.redirectUrl
    };
  } catch (error) {
    return {
      errorMessage: 'Kunde inte autentisiera användare...'
    };
  }
};

export const signOutUser = async (): Promise<boolean> => {
  try {
    await signOut(auth);
    return true;
  } catch (error) {
    // // console.log('===signOutUser===', error);
    return false;
  }
};

export const getAuthenticationSession = async (
  sessionId: string
): Promise<boolean> => {
  try {
    // Använder nu production functions istället för emulator
    // if (process.env.NODE_ENV !== 'production') {
    //   connectFunctionsEmulator(functions, 'localhost', 5001);
    // }
    const getAuthSession = httpsCallable(functions, CF.SESSION);
    const res = await getAuthSession({ sessionId });
    const resData = res.data as GetAuthSessionReturnType;

    if (!resData.data?.token) {
      return false;
    }

    const res1 = await signInWithCustomToken(auth, resData.data.token);
    return !!res1.user.uid;
  } catch (error) {
    return false;
  }
};
